import React from "react";
import { Col, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import "./LoginLayout.css";
import { Logo, LogotypePDK } from "wup-module1-base";

function LoginLayout() {
  return (
    <main>
      <div className="wrapper d-md-flex">
        <div className="login-side login-layout">
          <Row className="justify-content-center">
            <Col xs={"auto"}>
              <Row className="login-side-image-container align-items-center">
                <img
                  className="d-inline-block image-fluid login-side-image"
                  src={LogotypePDK}
                  alt="Logo MAŁOPOLSKI POCIĄG DO KARIERY"
                />
              </Row>
            </Col>
          </Row>
        </div>
        <div className="login-content overflow-auto login-layout-content">
          <div className="container">
            <Row className="justify-content-center align-items-center login-wrapper">
              <Col md={10} sm={12}>
                <Outlet />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LoginLayout;
